export default __webpack_public_path__ + "9530b62f399bf4e15db5c58e1d8a7600.png";